export const jarvisPrimeActionCenterConstants = {
  GET_PRIME_ACTION_CENTER_DATA_SAGA: "GET_PRIME_ACTION_CENTER_DATA_SAGA",
  GET_PRIME_ACTION_CENTER_DATA_APIS: "prime/action-centre",
  GET_PRIME_ACTION_CENTER_DATA_REQUEST: "GET_PRIME_ACTION_CENTER_DATA_REQUEST",
  GET_PRIME_ACTION_CENTER_DATA_RESPONSE:
    "GET_PRIME_ACTION_CENTER_DATA_RESPONSE",
};
